export const CONTROL = 'control' as const;

/**
 * Registry of known A/B experiments, keyed by backend `experimentName` (kebab-case).
 * 'control' MUST be the first variant of every experiment — it is the silent
 * fallback for unassigned/unknown. Deleting an entry turns every
 * `useExperiment('x')` for it into a TypeScript error.
 */
export const EXPERIMENTS = {
  'order-present-payment-methods': {
    variants: ['control', 'recommended-first'],
    owner: 'payments',
    ticket: 'NPP-7973',
  },
  'method-badge': {
    variants: ['control', 'badge-on'],
    owner: 'payments',
    ticket: 'NPP-8030',
  },
} as const satisfies Record<
  string,
  {
    variants: readonly [string, ...string[]];
    owner: string;
    ticket: string;
  }
>;

export type ExperimentCode = keyof typeof EXPERIMENTS;
export type VariantOf<C extends ExperimentCode> = (typeof EXPERIMENTS)[C]['variants'][number];

export const isKnownExperiment = (code: string): code is ExperimentCode =>
  Object.hasOwn(EXPERIMENTS, code);

export const isKnownVariant = (code: ExperimentCode, variant: string): boolean =>
  (EXPERIMENTS[code].variants as readonly string[]).includes(variant);
